import { render, staticRenderFns } from "./AIAdmin.vue?vue&type=template&id=62262526"
import script from "./AIAdmin.vue?vue&type=script&lang=js"
export * from "./AIAdmin.vue?vue&type=script&lang=js"
import style0 from "./AIAdmin.vue?vue&type=style&index=0&id=62262526&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports